<template>
    <div class="deviceConf">
        <div class="page-header">
            <page-header></page-header>
            <div class="option-select">
                <div class="charts-input">
                    <el-button type='primary' :loading="loading" @click="loadDeviceConf(false)">{{loading ? '正在加载' : '手动刷新'}}</el-button>
                </div>
            </div>
        </div>

        <div class="css-margin-top controlSet">
            <el-card class="box-card" body-style>
                <div class="clearfix chars-header">
                    <span class="card-header-title">设备配置表</span>
                    <span class="time-show">{{deviceConf.time_stamp}}</span>
                    <span></span>
                    <!--<div v-if="!isEdit">-->
                        <!--<el-button @click="openEdit" type="text">编辑</el-button>-->
                    <!--</div>-->
                    <!--<div v-else>-->
                        <!--<el-button v-show="isEdit" @click="isEdit=false" type="text">取消</el-button>-->
                        <!--<el-button @click="saveDeviceConf" :loading="loading" v-show="isEdit" type="success">-->
                            <!--{{loading ? '正在加载' : '保存并写入设备'}}-->
                        <!--</el-button>-->
                    <!--</div>-->
                </div>
                <div v-if="!loading">
                    <div v-if="!isMobile" class="table-list">
                        <template>
                            <el-table :data="deviceConf.data.slice(0,Math.round(deviceConf.data.length/2))"
                                      class="val-table">
                                <el-table-column prop="name" label="参数名">
                                    <template scope="scope">
                                        <p>{{deviceConfName[scope.row.name]}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <el-input v-if="isEdit" v-model="scope.row.data"></el-input>
                                            <p v-else>{{scope.row.data}}</p>
                                        </div>
                                    </template>
                                </el-table-column>

                            </el-table>
                        </template>
                        <template>
                            <el-table :data="deviceConf.data.slice(Math.round(deviceConf.data.length/2))"
                                      class="val-table">
                                <el-table-column prop="name" label="参数名">
                                    <template scope="scope">
                                        <p>{{deviceConfName[scope.row.name]}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <el-input v-if="isEdit" v-model="scope.row.data"></el-input>
                                            <p v-else>{{scope.row.data}}</p>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>
                    <!--isMobile conf  -->
                    <div v-if="isMobile" class="table-list">
                        <template>
                            <el-table :data="deviceConf.data" class="mobile-val-table">
                                <el-table-column prop="name" label="参数名">
                                    <template scope="scope">
                                        <p>{{deviceConfName[scope.row.name]}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <!--<el-input v-if="isEdit" v-model="scope.row.data"></el-input>-->
                                            <p >{{scope.row.data}}</p>
                                        </div>

                                    </template>

                                </el-table-column>

                            </el-table>
                        </template>

                    </div>
                </div>
                <loading v-else></loading>

            </el-card>

        </div>
        <div class="css-margin-top" v-if="deviceName.data.length">
            <el-card class="box-card" body-style>
                <div class="clearfix chars-header">
                    <span class="card-header-title">设备名称表</span>
                </div>
                <div>
                    <div class="device-name-item" v-for="name in deviceName.data">
                        {{name}}
                    </div>

                </div>

            </el-card>

        </div>

    </div>
</template>

<script>
    import {mapState} from "vuex"
    import pageHeader from '../../components/tempControl/header'
    import loading from '../../components/common/loading.vue'
    import Lib from '../../lib/lib'

    export default {

        name: "deviceConf",
        components: {
            pageHeader,
            loading
        },
        data() {
            return {
                option: {
                    sys_alias: ''
                },
                sys_alias: '',
                loading: true,
                isEdit: '',
                deviceConf: {
                    data: [],
                    time_stamp: ''
                },

                deviceName: {
                    data: '',
                    time_stamp: ''
                },
                deviceConfName:{},
                //设备配置对应中文名
                peimei: {
                    //4-20mA 重量输入名称条数, int,0 ~255，不可空

nAiNum:'重量输入名称条数',

//AO 输出名称条数, int,0 ~255，不可空

nAoNum:'输出名称条数',

//DI 输入名称表, int,0 ~255，不可空

nDiNum:'输入名称表',

//DO 输出名称表, int,0 ~255，不可空

nDoNum:'输出名称表',

//电子称总数, int,0 ~255，不可空

mAiNum:'电子称总数',

//自控提示、报警类型数, int,0 ~255，不可空

nAutoNum:'自控提示、报警类型数',

//数据总数, int,0 ~255，不可空

nNameNum:'数据总数',



//标准参数Uchar类型个数，int,0 ~255，不可空

bzcsUchar:'标准参数Uchar类型个数',

//标准参数Char类型个数，int,0 ~255，不可空

bzcsChar:'标准参数Char类型个数',

//标准参数Uint类型个数，int,0 ~255，不可空

bzcsUint:'标准参数Uint类型个数',

//标准参数Int类型个数，int,0 ~255，不可空

bzcsInt:'标准参数Int类型个数',

//标准参数Ulong类型个数，int,0 ~255，不可空

bzcsUlong:'标准参数Ulong类型个数',

//标准参数Long类型个数，int,0 ~255，不可空

bzcsLong:'标准参数Long类型个数',

//标准参数Float类型个数，int,0 ~255，不可空

bzcsFloat:'标准参数Float类型个数',

//自控参数Uchar类型个数，int,0 ~255，不可空

zkcsUchar:'自控参数Uchar类型个数',

//自控参数Char类型个数，int,0 ~255，不可空

zkcsChar:'自控参数Char类型个数',

//自控参数Uint类型个数，int,0 ~255，不可空

zkcsUint:'自控参数Uint类型个数',

//自控参数Int类型个数，int,0 ~255，不可空

zkcsInt:'自控参数Int类型个数',

//自控参数Ulong类型个数，int,0 ~255，不可空

zkcsUlong:'自控参数Ulong类型个数',

//自控参数Long类型个数，int,0 ~255，不可空

zkcsLong:'自控参数Long类型个数',

//自控参数Float类型个数，int,0 ~255，不可空

zkcsFloat:'自控参数Float类型个数',

//自控变量Uchar类型个数，int,0 ~255，不可空

zkblUchar:'自控变量Uchar类型个数',

//自控变量Char类型个数，int,0 ~255，不可空

zkblChar:'自控变量Char类型个数',

//自控变量Uint类型个数，int,0 ~255，不可空

zkblUint:'自控变量Uint类型个数',

//自控变量Int类型个数，int,0 ~255，不可空

zkblInt:'自控变量Int类型个数',

//自控变量Ulong类型个数，int,0 ~255，不可空

zkblUlong:'自控变量Ulong类型个数',

//自控变量Long类型个数，int,0 ~255，不可空

zkblLong:'自控变量Long类型个数',

//自控变量Float类型个数，int,0 ~255，不可空

zkblFloat:'自控变量Float类型个数',
                },
                peishui:{
                    //4-20mA 重量输入名称条数, int,0 ~255，不可空

                    mAiNum:"重量输入名称条数",

//AO 输出名称条数, int,0 ~255，不可空

                    nAoNum:"输出名称条数",

//DI 输入名称表, int,0 ~255，不可空

                    nDiNum:'输入名称表',

//DO 输出名称表, int,0 ~255，不可空

                    nDoNum:'输出名称表',

//电子称总数, int,0 ~255，不可空

                    nAiNum:'电子称总数',

//自控提示、报警类型数, int,0 ~255，不可空

                    nAutoNum:'自控提示、报警类型数',

//数据总数, int,0 ~255，不可空

                    nNameNum:'数据总数',



//标准参数Uchar类型个数，int,0 ~255，不可空

                    nReUchar:'实时数据Uchar类型个数',

//标准参数Char类型个数，int,0 ~255，不可空

                    nReChar:'实时数据Char类型个数',

//标准参数Uint类型个数，int,0 ~255，不可空

                    nReUint:'实时数据Uint类型个数',

//标准参数Int类型个数，int,0 ~255，不可空

                    nReInt:'实时数据Int类型个数',

//标准参数Ulong类型个数，int,0 ~255，不可空

                    nReUlong:'实时数据Ulong类型个数',

//标准参数Long类型个数，int,0 ~255，不可空

                    nReLong:'实时数据Long类型个数',

//标准参数Float类型个数，int,0 ~255，不可空

                    nReFloat:'实时数据Float类型个数',

//自控参数Uchar类型个数，int,0 ~255，不可空

                    zkcsUchar:'自控参数Uchar类型个数',

//自控参数Char类型个数，int,0 ~255，不可空

                    zkcsChar:'自控参数Char类型个数',

//自控参数Uint类型个数，int,0 ~255，不可空

                    zkcsUint:'自控参数Uint类型个数',

//自控参数Int类型个数，int,0 ~255，不可空

                    zkcsInt:'自控参数Int类型个数',

//自控参数Ulong类型个数，int,0 ~255，不可空

                    zkcsUlong:'自控参数Ulong类型个数',

//自控参数Long类型个数，int,0 ~255，不可空

                    zkcsLong:'自控参数Long类型个数',

//自控参数Float类型个数，int,0 ~255，不可空

                    zkcsFloat:'自控参数Float类型个数',

//自控变量Uchar类型个数，int,0 ~255，不可空

                    zkblUchar:'自控变量Uchar类型个数',

//自控变量Char类型个数，int,0 ~255，不可空

                    zkblChar:'自控变量Char类型个数',

//自控变量Uint类型个数，int,0 ~255，不可空

                    zkblUint:'自控变量Uint类型个数',

//自控变量Int类型个数，int,0 ~255，不可空

                    zkblInt:'自控变量Int类型个数',

//自控变量Ulong类型个数，int,0 ~255，不可空

                    zkblUlong:'自控变量Ulong类型个数',

//自控变量Long类型个数，int,0 ~255，不可空

                    zkblLong:'自控变量Long类型个数',

//自控变量Float类型个数，int,0 ~255，不可空

                    zkblFloat:'自控变量Float类型个数'
                },
                id_of_setinterval:''
            }
        },
        computed: mapState({
            isMobile: state => state.isMobile,
            deviceInfo: state => state.deviceInfo,
            userInfo: state => state.userInfo,
            config:state=>state.config
        }),
        created() {
            this.option.sys_alias = '1'
            this.deviceConfName=(this.deviceInfo.category==='配煤'?this.peimei:this.peishui);
            this.initData(true);
            this.timingLoadData('OPEN')


        },
        beforeDestroy(){
          this.timingLoadData('CLOSE')
        },
        methods: {
            // 定时任务
            timingLoadData(type) {
                if (type === "OPEN") {
                    this.id_of_setinterval = setInterval(() => {
                        this.initData(false);
                    }, this.config.refreshInterval?this.config.refreshInterval:30000);
                } else {
                    clearInterval(this.id_of_setinterval);
                }
            },
            initData(type) {
                this.loading = true
                this.loadDeviceConf(type)
                this.loadDeviceName(type)
            },
            loadDeviceConf(is_cache) {
                this.loading = true

                let params
                params = {
                    sys_alias: this.option.sys_alias,
                    is_cache: is_cache,
                    device_id: this.deviceInfo.device_id
                }
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.loadDeviceSetting(params, (data) => {
                    this.loading = false
                    if (data.payload && data.payload.data) {
                        try {
//                            this.deviceConf =JSON.parse(data.payload.data)
                            let jsonData = JSON.parse(data.payload.data)
                            delete jsonData.oother
                            delete jsonData.isSuccess
                            delete jsonData.msg
                            this.deviceConf.data = []
                            for (let key in jsonData) {
                                if(this.deviceConfName[key]){
                                    this.deviceConf.data.push({
                                        name: key,
                                        data: jsonData[key]
                                    })

                                }

                            }
                            this.deviceConf.time_stamp = data.payload.time_stamp

                        } catch (err) {

                        }
                    } else {
                        if (is_cache) {
                            this.initData(false)
                        }
                    }
                })
            },
            loadDeviceName(is_cache) {
                let params
                params = {
                    sys_alias: this.option.sys_alias,
                    is_cache: is_cache,
                    device_id: this.deviceInfo.device_id
                }
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.loadDeviceName(params, (data) => {
                    if (data.payload && data.payload.data) {
                        try {
                            let data =  JSON.parse(data.payload.data)

                            this.deviceName.data =data
                            this.deviceName.time_stamp = data.payload.time_stamp
                        } catch (err) {
                            console.error()

                        }
                    }
                })

            },
            openEdit() {
                this.isEdit = true;
                this.initData(false)
            },
            saveDeviceConf() {
                let params = {
                    payload: this.dealDeviceConf(),
                    device_id: this.deviceInfo.device_id,
                    sys_alias: this.option.sys_alias,


                }
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.setDeviceSetting(params, data => {
                    if(data.status_code==='SUCCEEDED'){
                        this.$message.success('操作成功')
                    }else{
                        this.$message.error('操作失败')
                    }

                })


            },
            dealDeviceConf() {
                let data = this.deviceConf.data,
                    json = {}
                data.forEach(v => {
                    json[v.name] = v.data
                })
                json.devNo = this.option.sys_alias * 1
                return JSON.stringify(json)
            },



        }


    }
</script>

<style scoped>
    .set-option {
        display: flex;
        justify-content: space-between
    }

    .table-list {
        display: flex;
        width: 100%;
    }

    .el-card box-card {
        width: 100%
    }

    .chars-header {
        font-size: 0.22rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.3rem;
    }

    .val-table {
        width: 50%;
    }

    .table-list .el-table__header-wrapper thead div {
        background: #71B7FF
    }

    .scope-input {
        display: flex;
        align-items: center;
    }

    .scope-input > .el-input {
        flex: 1;
    }

    .scope-input > span {
        margin: 0 5px;
    }

    .edit-input {
        margin: 9px 0
    }

    .device-name-item {
        display: inline-block;
        width: 125px;
        margin: 20px 0;
    }
</style>




// WEBPACK FOOTER //
// deviceConf.vue?6480597a